import { render, staticRenderFns } from "./page_input.vue?vue&type=template&id=819287f8&scoped=true"
import script from "./page_input.vue?vue&type=script&lang=js"
export * from "./page_input.vue?vue&type=script&lang=js"
import style0 from "./page_input.vue?vue&type=style&index=0&id=819287f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819287f8",
  null
  
)

export default component.exports